export default __webpack_public_path__ + "static/media/variluxG9-bg-4.013502fb.png";